/* ==========================================================
   Polycarbonate Depot — Material Calculator v3
   Systems: 8mm Twin-wall | 16mm Triple-wall | U-Lock
   Input: inches
   ========================================================== */
(function () {
  'use strict';

  // ──────────────────────────────────────────────────────────
  // PRODUCT CATALOG
  // ──────────────────────────────────────────────────────────
  var PRODUCTS = {
    sheets: {
      'twin-8mm': {
        label: '5/16\u2033 (8mm) Twin-wall Sheet',
        sheetWidthIn: 48,
        colors: ['clear', 'bronze', 'opal'],
        variants: {
          clear:  { 96: 47288981520638, 144: 47288978800894, 192: 47288984043774, 288: 46165668102398 },
          bronze: { 96: 47288006246654, 144: 47288970969342, 192: 46074799554814, 240: 46630113313022, 288: 46218869997822 },
          opal:   { 96: 46096644833534, 144: 46096653287678, 192: 46152197177598, 240: 47694254997758, 288: 46167161405694 },
        },
        prices: {
          clear:  { 96: 75,  144: 110, 192: 170, 288: 280 },
          bronze: { 96: 75,  144: 110, 192: 170, 240: 225, 288: 280 },
          opal:   { 96: 75,  144: 110, 192: 170, 240: 225, 288: 280 },
        },
      },
      'triple-16mm': {
        label: '5/8\u2033 (16mm) Triple-wall Sheet',
        sheetWidthIn: 48,
        colors: ['clear', 'bronze'],
        variants: {
          clear:  { 96: 46050011250942, 144: 46050017411326, 192: 47625334882558 },
          bronze: { 96: 47410642518270, 144: 47625328230654, 192: 47287434084606 },
        },
        prices: {
          clear:  { 96: 140, 144: 200, 192: 300 },
          bronze: { 96: 140, 144: 200, 192: 300 },
        },
      },
    },
    hProfiles: {
      'twin-8mm': {
        label: 'H-Profile 5/16\u2033 (8mm)',
        variants: {
          clear:  { 96: 46030103314686, 144: 46030120419582 },
          bronze: { 96: 46030094663934, 144: 46376262959358 },
          opal:   { 96: 46096648667390, 144: 46114554347774 },
        },
        prices: {
          clear:  { 96: 15, 144: 20 },
          bronze: { 96: 15, 144: 20 },
          opal:   { 96: 15, 144: 20 },
        },
      },
      'triple-16mm': {
        label: 'H-Profile 5/8\u2033 (16mm)',
        variants: {
          clear: { 96: 47021104726270, 144: 47078817071358, 192: 47078816874750 },
        },
        prices: {
          clear: { 96: 25, 144: 35, 192: 50 },
        },
      },
    },
    uCaps: {
      'twin-8mm':    { label: 'U-Cap 5/16\u2033 (8mm) — 48"', variantId: 46030117830910, price: 5 },
      'triple-16mm': { label: 'U-Cap 5/8\u2033 (16mm) — 48"',  variantId: 47021106594046, price: 10 },
    },
    snapProfiles: {
      'twin-8mm': {
        label: 'Snap Profile 5/16\u2033 (8mm)',
        variants: {
          clear:  { 144: 46030115373310, 192: 46030116585726, 240: 46630117015806, 288: 45185998651646 },
          bronze: { 144: 46030112588030, 192: 46030113964286, 288: 46630114230526 },
        },
        prices: {
          clear:  { 144: 35, 192: 45, 240: 85, 288: 100 },
          bronze: { 144: 35, 192: 45, 288: 100 },
        },
      },
    },
    tapes: {
      vented:   { label: 'Vented Tape',   variantId: 45089748091134, price: 35 },
      aluminum: { label: 'Aluminum Tape', variantId: 46030180221182, price: 20 },
    },
    screws: {
      wood:  { label: 'Tapping Screws — Wood Frame (box of 50)',   variantId: 46961604919550, price: 30 },
      metal: { label: 'Neoprene Screws — Metal Frame (box of 50)', variantId: 46165029814526, price: 30 },
    },
    ulock: {
      clear:  { label: '10mm 4-wall U-Lock System (Clear)',  variantId: 47477690106110, pricePerSqft: 9 },
      bronze: { label: '10mm 4-wall U-Lock System (Bronze)', variantId: 47036342993150, pricePerSqft: 9 },
    },
  };

  // ──────────────────────────────────────────────────────────
  // HELPERS
  // ──────────────────────────────────────────────────────────

  /** Smallest available sheet length (in") >= targetIn, or null */
  function bestSheetLength(system, color, targetIn) {
    var lengths = Object.keys(PRODUCTS.sheets[system].variants[color])
      .map(Number).sort(function (a, b) { return a - b; });
    for (var i = 0; i < lengths.length; i++) {
      if (lengths[i] >= targetIn) return lengths[i];
    }
    return null;
  }

  /** Smallest available connector length (in") >= neededIn, or null */
  function bestConnectorLength(catalog, color, neededIn) {
    var lengths = Object.keys(catalog.variants[color])
      .map(Number).sort(function (a, b) { return a - b; });
    for (var i = 0; i < lengths.length; i++) {
      if (lengths[i] >= neededIn) return lengths[i];
    }
    return null;
  }

  /**
   * Profile color for connectors:
   * - triple-16mm H-Profile only available in clear
   * - bronze sheets  → bronze profile
   * - clear/opal sheets + H-Profile → opal profile
   * - clear/opal sheets + Snap Profile → clear (no opal snap)
   */
  function profileColorFor(system, sheetColor, useSnap) {
    if (system === 'triple-16mm') return 'clear';
    if (sheetColor === 'bronze') return 'bronze';
    return useSnap ? 'clear' : 'opal';
  }

  /**
   * Auto-select profile type:
   * - triple-16mm always uses H-Profile (no snap variant)
   * - twin-8mm: H-Profile for sheets <= 144", Snap for > 144"
   */
  function autoProfileType(system, sheetLengthIn) {
    if (system === 'triple-16mm') return 'h-profile';
    return sheetLengthIn <= 144 ? 'h-profile' : 'snap';
  }

  function ucFirst(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  function money(n) {
    var s = n.toFixed(2);
    return '$' + (s.slice(-3) === '.00' ? s.slice(0, -3) : s);
  }

  // ──────────────────────────────────────────────────────────
  // CALCULATION: Twin-wall / Triple-wall
  // ──────────────────────────────────────────────────────────
  function calcTwinTriple(p) {
    var widthIn     = p.widthIn;
    var lengthIn    = p.lengthIn;
    var system      = p.system;
    var color       = p.color;
    var installation = p.installation;
    var frameType   = p.frameType;

    var sheetData    = PRODUCTS.sheets[system];
    var totalSheets  = Math.ceil(widthIn / sheetData.sheetWidthIn);
    var sheetLengthIn = bestSheetLength(system, color, lengthIn);

    if (!sheetLengthIn) {
      var maxL = Math.max.apply(null,
        Object.keys(sheetData.variants[color]).map(Number)
      );
      return {
        error: 'Your project length (' + lengthIn + '\u2033) exceeds the maximum available sheet length of ' +
               maxL + '\u2033 for this system. Please contact us for a custom quote.',
      };
    }

    var profileType = autoProfileType(system, sheetLengthIn);
    var useSnap     = profileType === 'snap';
    var pColor      = profileColorFor(system, color, useSnap);

    var items = [];
    var total = 0;

    function addItem(label, qty, unitPrice, variantId, note) {
      var lineTotal = qty * unitPrice;
      items.push({ label: label, qty: qty, unitPrice: unitPrice, total: lineTotal, variantId: variantId, note: note || '' });
      total += lineTotal;
    }

    // 1. Sheets
    addItem(
      sheetData.label + ' ' + sheetLengthIn + '\u2033 \u2014 ' + ucFirst(color),
      totalSheets,
      sheetData.prices[color][sheetLengthIn],
      sheetData.variants[color][sheetLengthIn]
    );

    // 2. Connectors between sheets
    if (totalSheets > 1) {
      var numConn = totalSheets - 1;
      if (useSnap) {
        var snap     = PRODUCTS.snapProfiles[system];
        var connLen  = bestConnectorLength(snap, pColor, sheetLengthIn);
        if (connLen) {
          addItem(
            snap.label + ' ' + connLen + '\u2033 \u2014 ' + ucFirst(pColor),
            numConn,
            snap.prices[pColor][connLen],
            snap.variants[pColor][connLen],
            'Auto-selected: Snap Profile for sheets \u003e144\u2033'
          );
        }
      } else {
        var hp      = PRODUCTS.hProfiles[system];
        var hLen    = bestConnectorLength(hp, pColor, sheetLengthIn);
        if (hLen) {
          addItem(
            hp.label + ' ' + hLen + '\u2033 \u2014 ' + ucFirst(pColor),
            numConn,
            hp.prices[pColor][hLen],
            hp.variants[pColor][hLen],
            'Auto-selected: H-Profile for sheets \u2264144\u2033'
          );
        }
      }
    }

    // 3. U-Caps (always 2 per sheet)
    var uc      = PRODUCTS.uCaps[system];
    var uCapQty = totalSheets * 2;
    addItem(uc.label, uCapQty, uc.price, uc.variantId);

    // 4. Vented Tape (always 1 roll)
    addItem(PRODUCTS.tapes.vented.label, 1, PRODUCTS.tapes.vented.price, PRODUCTS.tapes.vented.variantId);

    // 5. Aluminum Tape (only when >= 10 sheets)
    if (totalSheets >= 10) {
      addItem(PRODUCTS.tapes.aluminum.label, 1, PRODUCTS.tapes.aluminum.price, PRODUCTS.tapes.aluminum.variantId);
    }

    // 6. Screws
    var screw       = PRODUCTS.screws[frameType] || PRODUCTS.screws.wood;
    var screwsTotal = Math.ceil(sheetLengthIn / 12) * totalSheets;
    var screwPacks  = Math.ceil(screwsTotal / 50);
    addItem(screw.label, screwPacks, screw.price, screw.variantId);

    return { items: items, total: total, profileType: profileType, sheetLengthIn: sheetLengthIn, totalSheets: totalSheets };
  }

  // ──────────────────────────────────────────────────────────
  // CALCULATION: U-Lock system
  // ──────────────────────────────────────────────────────────
  function calcULock(p) {
    var widthIn  = p.widthIn;
    var lengthIn = p.lengthIn;
    var color    = p.color;
    var sqft     = Math.ceil((widthIn * lengthIn) / 144);
    var ulData   = PRODUCTS.ulock[color] || PRODUCTS.ulock.clear;
    var lineTotal = sqft * ulData.pricePerSqft;
    return {
      items: [{
        label:     ulData.label,
        qty:       sqft,
        unitPrice: ulData.pricePerSqft,
        total:     lineTotal,
        variantId: ulData.variantId,
        note:      'All hardware and accessories included',
      }],
      total: lineTotal,
    };
  }

  // ──────────────────────────────────────────────────────────
  // SVG DIAGRAM
  // ──────────────────────────────────────────────────────────
  function arrowH(x1, y1, x2, c) {
    c = c || '#DC2626';
    return '<line x1="' + (x1+8) + '" y1="' + y1 + '" x2="' + (x2-8) + '" y2="' + y1 + '" stroke="' + c + '" stroke-width="1.5"/>' +
      '<polygon points="' + x1 + ',' + (y1-4) + ' ' + x1 + ',' + (y1+4) + ' ' + (x1+9) + ',' + y1 + '" fill="' + c + '"/>' +
      '<polygon points="' + x2 + ',' + (y1-4) + ' ' + x2 + ',' + (y1+4) + ' ' + (x2-9) + ',' + y1 + '" fill="' + c + '"/>';
  }
  function arrowV(x, y1, y2, c) {
    c = c || '#DC2626';
    return '<line x1="' + x + '" y1="' + (y1+8) + '" x2="' + x + '" y2="' + (y2-8) + '" stroke="' + c + '" stroke-width="1.5"/>' +
      '<polygon points="' + (x-4) + ',' + y1 + ' ' + (x+4) + ',' + y1 + ' ' + x + ',' + (y1+9) + '" fill="' + c + '"/>' +
      '<polygon points="' + (x-4) + ',' + y2 + ' ' + (x+4) + ',' + y2 + ' ' + x + ',' + (y2-9) + '" fill="' + c + '"/>';
  }

  var diagramSvg = '<svg viewBox="0 0 300 210" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<rect x="55" y="48" width="180" height="120" rx="2" fill="#DBEAFE" stroke="#3B82F6" stroke-width="2"/>' +
    '<line x1="115" y1="48" x2="115" y2="168" stroke="#93C5FD" stroke-width="1" stroke-dasharray="5,4"/>' +
    '<line x1="175" y1="48" x2="175" y2="168" stroke="#93C5FD" stroke-width="1" stroke-dasharray="5,4"/>' +
    '<circle cx="55" cy="48" r="5" fill="#1E40AF"/><circle cx="235" cy="48" r="5" fill="#1E40AF"/>' +
    '<circle cx="55" cy="168" r="5" fill="#1E40AF"/><circle cx="235" cy="168" r="5" fill="#1E40AF"/>' +
    arrowH(55, 30, 235) +
    '<text x="145" y="24" text-anchor="middle" font-size="12" font-weight="700" fill="#DC2626" font-family="system-ui,sans-serif">WIDTH</text>' +
    arrowV(258, 48, 168) +
    '<text x="282" y="113" text-anchor="middle" font-size="12" font-weight="700" fill="#DC2626" font-family="system-ui,sans-serif" transform="rotate(90,282,113)">LENGTH</text>' +
    '<text x="145" y="113" text-anchor="middle" font-size="11" fill="#6B7280" font-family="system-ui,sans-serif">Panels</text>' +
    '</svg>';

  // ──────────────────────────────────────────────────────────
  // ADD ALL TO CART
  // ──────────────────────────────────────────────────────────
  var cartSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">' +
    '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>' +
    '<path stroke-linecap="round" stroke-linejoin="round" d="M1 1h4l2.68 13.39a2 2 0 001.99 1.61h9.72a2 2 0 001.99-1.61L23 6H6"/>' +
    '</svg>';

  window.calcAddAllToCart = function (btn) {
    var items;
    try { items = JSON.parse(btn.getAttribute('data-items')); } catch (e) { return; }
    btn.disabled = true;
    btn.textContent = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) { return r.json(); }).then(function () {
      btn.textContent = '\u2713 Added to Cart';
      btn.style.background = '#22c55e';
      setTimeout(function () {
        btn.disabled = false;
        btn.innerHTML = cartSvg + ' Add All to Cart';
        btn.style.background = '';
      }, 3000);
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Error \u2014 Try Again';
    });
  };

  // ──────────────────────────────────────────────────────────
  // UI CONTROLLER
  // ──────────────────────────────────────────────────────────
  var CalcUI = {
    step: 1,

    init: function () {
      this.$body    = document.getElementById('calc-body');
      this.$diagram = document.getElementById('calc-diagram');
      this.$results = document.getElementById('calc-results');
      this.$next1   = document.getElementById('calc-next-1');
      this.$next2   = document.getElementById('calc-next-2');
      this.$backBtn = document.getElementById('calc-back-btn');
      this.$backLbl = document.getElementById('calc-back-label');
      this.$widthIn = document.getElementById('calc-width');
      this.$lenIn   = document.getElementById('calc-length');
      this.$dots    = document.querySelectorAll('.calc-dot');

      if (!this.$body) return;

      // Render diagram
      if (this.$diagram) this.$diagram.innerHTML = diagramSvg;

      // Show step 1 on init
      this.showStep(1);

      // Navigation
      var self = this;
      if (this.$next1) this.$next1.addEventListener('click', function () { self.showStep(2); });
      if (this.$next2) this.$next2.addEventListener('click', function () { self.calculate(); self.showStep(3); });
      if (this.$backBtn) {
        this.$backBtn.addEventListener('click', function () {
          self.showStep(Math.max(1, self.step - 1));
        });
      }

      // System change handler
      var systemRadios = document.querySelectorAll('input[name="system-type"]');
      for (var i = 0; i < systemRadios.length; i++) {
        systemRadios[i].addEventListener('change', function () { self.onSystemChange(); });
      }

      // Live recalc on any form change
      var formEls = document.querySelectorAll('#calc-form input, #calc-form select');
      for (var j = 0; j < formEls.length; j++) {
        (function (el) {
          el.addEventListener('change', function () { self.calculate(); });
          if (el.type === 'number') {
            el.addEventListener('input', function () { self.calculate(); });
          }
        })(formEls[j]);
      }

      // Render quick-size preset buttons
      this.renderPresets();

      // Apply initial system state
      this.onSystemChange();

      // Re-evaluate step visibility on window resize
      window.addEventListener('resize', function () { self.showStep(self.step); });
    },

    showStep: function (n) {
      this.step = n;
      var isDesktop = window.innerWidth >= 750;
      var steps = document.querySelectorAll('.calc-step');
      for (var i = 0; i < steps.length; i++) {
        // On desktop: always show all form steps (1 & 2) side by side
        // On mobile: show only the current step
        steps[i].hidden = isDesktop ? false : (parseInt(steps[i].getAttribute('data-step'), 10) !== n);
      }
      for (var j = 0; j < this.$dots.length; j++) {
        var active = parseInt(this.$dots[j].getAttribute('data-step'), 10) === n;
        this.$dots[j].classList.toggle('is-active', active);
      }
      if (this.$results) {
        this.$results.classList.toggle('is-mobile-visible', n === 3);
      }
      if (this.$backLbl) {
        this.$backLbl.textContent = n === 2 ? 'How to measure' : 'Back';
      }
    },

    getSystem: function () {
      var r = document.querySelector('input[name="system-type"]:checked');
      return r ? r.value : 'twin-8mm';
    },

    onSystemChange: function () {
      var system  = this.getSystem();
      var isUlock = system === 'ulock';
      var is16mm  = system === 'triple-16mm';

      // Opal color option: not available for 16mm or U-Lock
      var opalCard  = document.getElementById('calc-color-opal');
      if (opalCard) {
        var hideOpal = is16mm || isUlock;
        opalCard.hidden = hideOpal;
        if (hideOpal) {
          var opalInput = opalCard.querySelector('input');
          if (opalInput && opalInput.checked) {
            var clearInput = document.querySelector('input[name="panel-color"][value="clear"]');
            if (clearInput) clearInput.checked = true;
          }
        }
      }

      // Installation section: hidden for U-Lock
      var installSec = document.getElementById('calc-installation-section');
      if (installSec) installSec.hidden = isUlock;

      // Frame type section: hidden for U-Lock
      var frameSec = document.getElementById('calc-frame-section');
      if (frameSec) frameSec.hidden = isUlock;

      this.calculate();
    },

    getParams: function () {
      var widthIn    = parseFloat(this.$widthIn && this.$widthIn.value) || 0;
      var lengthIn   = parseFloat(this.$lenIn   && this.$lenIn.value)   || 0;
      var system     = this.getSystem();
      var colorEl    = document.querySelector('input[name="panel-color"]:checked');
      var color      = colorEl ? colorEl.value : 'clear';
      var installEl  = document.querySelector('input[name="installation"]:checked');
      var installation = installEl ? installEl.value : 'freestanding';
      var frameEl    = document.querySelector('input[name="frame-type"]:checked');
      var frameType  = frameEl ? frameEl.value : 'wood';
      var installServiceEl = document.querySelector('input[name="installation-service"]:checked');
      var needsInstall = installServiceEl ? installServiceEl.value : 'no';
      return { widthIn: widthIn, lengthIn: lengthIn, system: system, color: color, installation: installation, frameType: frameType, needsInstall: needsInstall };
    },

    calculate: function () {
      var p = this.getParams();
      if (!p.widthIn || !p.lengthIn) { this.renderEmpty(); return; }
      var result = p.system === 'ulock' ? calcULock(p) : calcTwinTriple(p);
      if (result.error) {
        this.renderError(result.error);
      } else {
        this.renderResults(result, p);
      }
    },

    renderEmpty: function () {
      if (!this.$results) return;
      this.$results.innerHTML =
        '<div class="calc-results-empty">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<rect x="2" y="2" width="20" height="20" rx="2"/>' +
        '<line x1="8" y1="7" x2="16" y2="7"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="8" y1="17" x2="12" y2="17"/>' +
        '</svg>' +
        '<p>Enter your dimensions<br>to see the materials list</p>' +
        '</div>';
    },

    renderError: function (msg) {
      if (!this.$results) return;
      this.$results.innerHTML = '<div class="calc-results-error"><p>\u26a0\ufe0f ' + msg + '</p></div>';
    },

    renderResults: function (result, params) {
      if (!this.$results) return;
      var items        = result.items;
      var total        = result.total;
      var profileType  = result.profileType;
      var sheetLenIn   = result.sheetLengthIn;
      var numSheets    = result.totalSheets;
      var needsInstall = params && params.needsInstall === 'yes';

      var subParts = [];
      if (numSheets) {
        subParts.push(numSheets + ' panel' + (numSheets > 1 ? 's' : '') + ' \u00d7 ' + sheetLenIn + '\u2033 long');
      }
      if (profileType) {
        subParts.push(profileType === 'snap'
          ? 'Snap Profile (sheets \u003e144\u2033)'
          : 'H-Profile (sheets \u2264144\u2033)');
      }

      var rows = '';
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        rows +=
          '<tr>' +
          '<td class="calc-td-name">' + item.label +
            (item.note ? '<br><small style="color:rgba(var(--color-foreground),.45);font-size:1.05rem">' + item.note + '</small>' : '') +
          '</td>' +
          '<td class="calc-td-qty">' + item.qty + '</td>' +
          '<td class="calc-td-price">' + money(item.unitPrice) + '</td>' +
          '<td class="calc-td-price">' + money(item.total) + '</td>' +
          '</tr>';
      }

      var installHtml = '';
      if (needsInstall) {
        var installCost = total * 1.6;
        var grandTotal  = total + installCost;
        installHtml =
          '<div class="calc-cover-note calc-cover-note--warn">' +
          '<strong>Installation Service</strong>: <strong>' + money(installCost) + '</strong><br>' +
          '<small>Total incl. installation: <strong>' + money(grandTotal) + '</strong>. Final quote provided after site assessment.</small>' +
          '</div>';
      }

      var cartItems = JSON.stringify(
        items.map(function (it) { return { id: it.variantId, quantity: it.qty }; })
      );

      this.$results.innerHTML =
        '<div class="calc-results-inner">' +
          '<div class="calc-results-head">' +
            '<h3 class="calc-results-title">Materials List</h3>' +
            (subParts.length ? '<p class="calc-results-sub">' + subParts.join(' \u00b7 ') + '</p>' : '') +
          '</div>' +
          '<table class="calc-table" aria-label="Materials list">' +
            '<thead><tr>' +
              '<th>Item</th>' +
              '<th style="text-align:right">Qty</th>' +
              '<th style="text-align:right">Unit</th>' +
              '<th style="text-align:right">Total</th>' +
            '</tr></thead>' +
            '<tbody>' + rows + '</tbody>' +
            '<tfoot><tr>' +
              '<td colspan="3">Estimated Total</td>' +
              '<td class="calc-td-price">' + money(total) + '</td>' +
            '</tr></tfoot>' +
          '</table>' +
          installHtml +
          '<p class="calc-price-note">* Prices are estimates. Shipping not included.</p>' +
          '<div class="calc-result-actions">' +
            '<button class="calc-btn-primary" data-items=\'' + cartItems + '\' type="button" onclick="calcAddAllToCart(this)">' +
              cartSvg + ' Add All to Cart' +
            '</button>' +
          '</div>' +
          '<p class="calc-contact-note">Questions? <a href="/pages/contact">Contact us</a> for a free quote.</p>' +
        '</div>';
    },

    renderPresets: function () {
      var self     = this;
      var presets  = [
        { w: 120, l: 144, label: '10\u00d712 ft' },
        { w: 144, l: 192, label: '12\u00d716 ft' },
        { w: 192, l: 240, label: '16\u00d720 ft' },
        { w: 240, l: 240, label: '20\u00d720 ft' },
        { w: 240, l: 288, label: '20\u00d724 ft' },
      ];
      var container = document.querySelector('.calc-preset-btns');
      if (!container) return;
      var html = '';
      for (var i = 0; i < presets.length; i++) {
        html += '<button class="calc-preset-btn" type="button" data-w="' + presets[i].w +
          '" data-l="' + presets[i].l + '">' + presets[i].label + '</button>';
      }
      container.innerHTML = html;
      var btns = container.querySelectorAll('.calc-preset-btn');
      for (var j = 0; j < btns.length; j++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            if (self.$widthIn) self.$widthIn.value = btn.getAttribute('data-w');
            if (self.$lenIn)   self.$lenIn.value   = btn.getAttribute('data-l');
            self.calculate();
          });
        })(btns[j]);
      }
    },
  };

  // ──────────────────────────────────────────────────────────
  // BOOT
  // ──────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { CalcUI.init(); });
  } else {
    CalcUI.init();
  }

})();
